import React from 'react';
import { useResourceContext } from 'react-admin';
import Heading from 'components/Heading';
import MoneyInput from 'components/MoneyInput';
import { formatCents } from 'utils/rateSettings/SharedRateSettingsForm.utils';

type MinimumWageInputsProps = {
  settingsField: string;
  inheritedSettings: any;
};

export const MinimumWageInputs = ({ settingsField, inheritedSettings }: MinimumWageInputsProps) => {
  const resource = useResourceContext();

  return (
    <>
      <Heading>Minimum Wage</Heading>
      <MoneyInput
        label="RN minimum wage"
        source={`${settingsField}.rn_minimum_wage_cents`}
        helperText={formatCents(inheritedSettings?.rn_minimum_wage_cents)}
      />
      <MoneyInput
        label="LVN minimum wage"
        source={`${settingsField}.lvn_minimum_wage_cents`}
        helperText={formatCents(inheritedSettings?.lvn_minimum_wage_cents)}
      />
      <MoneyInput
        label="Allied minimum wage"
        source={`${settingsField}.allied_minimum_wage_cents`}
        helperText={formatCents(inheritedSettings?.allied_minimum_wage_cents)}
      />
      {resource === 'StateRateSetting' && (
        <MoneyInput
          label="W2 minimum Wage"
          source={`${settingsField}.w2_minimum_wage_cents`}
          helperText={formatCents(inheritedSettings?.w2_minimum_wage_cents)}
        />
      )}
    </>
  );
};
